import { useQuery } from "@tanstack/react-query";
import { getSupabaseWithLogging } from "@/lib/hooks/api/utils";
import {
  TASK_WITH_CONTACT_AND_USER_SELECT,
  hydrateAssignedUsersForTask,
} from "./helpers";

export function useTask(id: string) {
  return useQuery({
    queryKey: ["task", id],
    queryFn: async () => {
      const supabase = getSupabaseWithLogging();
      const { data, error } = await supabase
        .from("contact_tasks")
        .select(TASK_WITH_CONTACT_AND_USER_SELECT)
        .eq("id", id)
        .single();

      if (error) {
        console.error("Error fetching task:", error);
        throw new Error(error.message);
      }

      try {
        await hydrateAssignedUsersForTask(data);
      } catch (error) {
        console.error("Error processing assigned_users:", error);
      }

      return data;
    },
    enabled: !!id,
  });
}
